import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Tray } from './Tray';
import { TrayMenuWidget } from './TrayMenuWidget';
import { TrayModeOption } from './TrayMode';

export const trayPropertyLayout = LockablePropertyStripLayout<Tray>((d, s, o, w, a) => [
    w.createPopout({
        facade: a,
        text: TrayModeOption.get(a.get('mode'))?.label ?? 'None',
        ui: TrayMenuWidget,
    }),
    w.createDivide(),
    w.createButton({
        text: 'Horizontal/Vertical',
        onAction() {
            o.update(() => {
                a.set('flow', a.get('flow') === 'row' ? 'column' : 'row');
            });
        }
    }),
    w.createDivide(),
    ...lockAndMoreLayout(d, s, o, w, a),
]);

